"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleStateTaxCalculation = void 0;
function handleStateTaxCalculation(brackets, stateTax, salary, filingStatus, federalTaxes) {
    var _a, _b, _c;
    var stateTaxes = 0;
    if (stateTax.type === "none") {
        return stateTaxes;
    }
    else {
        var adjustedGrossIncome = salary -
            ((((_a = stateTax[filingStatus]) === null || _a === void 0 ? void 0 : _a.standardDeduction) || 0) +
                (((_b = stateTax[filingStatus]) === null || _b === void 0 ? void 0 : _b.personalExemption) || 0));
        if (stateTax.canDeductFederalTaxes) {
            adjustedGrossIncome -= federalTaxes;
        }
        for (var _i = 0, _d = (_c = stateTax[filingStatus]) === null || _c === void 0 ? void 0 : _c.brackets; _i < _d.length; _i++) {
            var interval = _d[_i];
            if (adjustedGrossIncome < interval[1]) {
                stateTaxes += (adjustedGrossIncome - interval[0]) * interval[2];
                break;
            }
            else {
                stateTaxes += (interval[1] - interval[0]) * interval[2];
            }
        }
        if (stateTax.otherTaxFunction) {
            stateTaxes += stateTax.otherTaxFunction(salary);
        }
    }
    return stateTaxes;
}
exports.handleStateTaxCalculation = handleStateTaxCalculation;
